export default __webpack_public_path__ + "a5a3f6ffd50b473562624ef1ab7d893e.jpg";